<template>
	<div class="departments">
		<FunctionTitle :title="main_title" />
		<CommonFlame :title="sub_title">
			<template v-if="!$vuetify.breakpoint.xs && authority_flag" v-slot:app-bar-btn>
				<DepartmentNewDialog text />
			</template>
			<v-sheet elevation="0">
				<v-row v-if="$vuetify.breakpoint.xs && authority_flag" no-gutters justify="end">
					<DepartmentNewDialog />
				</v-row>
				<div class="table-container mt-4">
					<v-data-table
						locale="ja-JP"
						:headers="headers"
						:items="$store.getters.departments"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr class="no-click">
								<td >
									{{ item.name }}
								</td>
								<td class="pa-1">
									<v-row no-gutters justify="space-around" align="center">
										<v-btn
											color="secondary"
											@click="
												$router.push({ name: 'department_user_index', params: { id: item.id } })
											"
										>
											<v-icon class="mr-1">mdi-page-next-outline</v-icon>
											所属社員一覧
										</v-btn>
									</v-row>
								</td>
								<td class="pa-1">
									<template v-if="authority_flag">
										<v-row no-gutters justify="space-around" align="center">
											<v-btn color="secondary" @click="openEditDialog(item)">
												<v-icon class="mr-1">mdi-pencil</v-icon>
												編集
											</v-btn>
										</v-row>
									</template>
								</td>
								<td class="pa-1">
									<template v-if="authority_flag">
										<v-row no-gutters justify="space-around" align="center">
											<TemplateDeleteDialog
												ref="“deleteDialog”"
												:openBtnColor="'red'"
												:openBtnDesign="['dark']"
											>
												<template v-slot:btn-text>削除</template>
												<template v-slot:button>
													<v-row no-gutters justify="center">
														<v-btn
															class="ma-1"
															@click="deleteDepartment(item.id)"
															dense
															dark
															color="red"
														>
															削除する
														</v-btn>
													</v-row>
												</template>
											</TemplateDeleteDialog>
										</v-row>
									</template>
								</td>
							</tr>
						</template>
					</v-data-table>
				</div>
			</v-sheet>
		</CommonFlame>
		<DepartmentEditDialog :dialog.sync="editDialog" :department="selectedDepartment" />
	</div>
</template>

<script>
import errorHandling from "../../helper/errorHandling"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import TemplateDeleteDialog from "../shared/TemplateDeleteDialog.vue"
import DepartmentEditDialog from "./components/DepartmentEditDialog.vue"
import DepartmentNewDialog from "./components/DepartmentNewDialog.vue"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
		TemplateDeleteDialog,
		DepartmentEditDialog,
		DepartmentNewDialog,
	},
	data() {
		return {
			departments: this.$store.getters.departments,
			authority_flag: false,
			editDialog: false,
			selectedDepartment: {},
			main_title: "部門一覧",
			sub_title: "各部門情報",
			headers: [
				{ text: "部門名", value: "name", width: "280px" },
				{ text: "", value: "", width: "100px" },
				{ text: "", value: "", width: "100px" },
				{ text: "", value: "", width: "100px" },
			],
		}
	},

	mounted() {
		this.fetchDepartments()
	},

	methods: {
		fetchDepartments() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/departments", { headers })
				.then((res) => {
					this.$store.commit("setDepartments", res.data.departments)
					this.authority_flag = res.data.authority_flag
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openEditDialog(department) {
			this.selectedDepartment = department
			this.editDialog = true
		},
		deleteDepartment(id) {
			const headers = authenticate.setHeader()
			const delete_id = id
			axios
				.delete(`/erp/v1/departments/${delete_id}`, { headers })
				.then((res) => {
					this.$store.commit("deleteDepartment", delete_id)
					this.$store.dispatch("setFlash", {
						text: "削除しました",
						type: "notice",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>